import axios from '../../../utils/http/axios-local'

export const postProcessorField = (
  fieldName: string,
  fieldType: string,
  portalId: number
) => {
  let type = 0
  if (fieldType === 'pdf') {
    type = 1
  }

  if (fieldType === 'png') {
    type = 2
  }
  return axios.post<{ templateId: number }>('/det/tooling/processor_fields', {
    processor_field: {
      name: fieldName,
      data_type: type,
      portal_id: portalId
    }
  })
}
